import { addtrackVisitorpublic } from 'api/visitor/_requests';
import { addtrackVisitor } from 'api/visitor/_requests';
import { useEffect, useCallback } from 'react';
import { useLocation } from 'react-router-dom';

const THROTTLE_TIME = 5000; // 5 seconds throttle per page

const useVisitor = (isLoggedIn: boolean) => {
  const location = useLocation();

  // Wrapper to get and set last hits safely
  const getLastHits = useCallback(() => {
    try {
      return JSON.parse(sessionStorage.getItem('lastPageHits') || '{}');
    } catch {
      return {};
    }
  }, []);

  const setLastHits = useCallback((hits: Record<string, number>) => {
    try {
      sessionStorage.setItem('lastPageHits', JSON.stringify(hits));
    } catch {
      // ignore sessionStorage write errors
    }
  }, []);

  useEffect(() => {
    const page = location.pathname;
    const now = Date.now();

    const lastHits = getLastHits();

    if (!lastHits[page] || now - lastHits[page] > THROTTLE_TIME) {
      const trackFn = isLoggedIn ? addtrackVisitor : addtrackVisitorpublic;

      trackFn({ url: page })
        .then(() => {
          lastHits[page] = now;
          setLastHits(lastHits);
        })
        .catch(err => {
          console.error('Tracking error:', err);
        });
    }
  }, [location.pathname, isLoggedIn, getLastHits, setLastHits]);
};

export default useVisitor;
